import get from 'lodash/get';
import { CONSENT_MODES } from 'api/consent-modes/modes';
import effectiveConsentMode from 'api/consent-modes/utils/effectiveConsentMode';

// Wire shape consumed by Roost's consent middleware:
//   Row absent (legacy)           -> null (caller omits the `consent` key)
//   ACE mode with category        -> { mode: 'CONSENT_MODE_ACE', category }
//   External mode (no category)   -> { mode: 'CONSENT_MODE_EXTERNAL' }
export default function buildIntegrationConsent(pipelineIntegrationConsent) {
  if (!pipelineIntegrationConsent) {
    return null;
  }

  const { mode, consentCategory } = pipelineIntegrationConsent;
  const consentMode = effectiveConsentMode(mode);
  const categoryCode = get(consentCategory, 'code');

  // EXTERNAL = consent is handled outside of metarouter, no category
  if (consentMode === CONSENT_MODES.external) {
    return { mode: consentMode };
  }

  // ACE = advanced consent enforcement, requires category
  if (consentMode === CONSENT_MODES.ace && categoryCode) {
    return { mode: consentMode, category: categoryCode };
  }

  // TODO: (bburkett) - consent mode - future support for TCF to be added here

  // an overly defensive "shouldn't happen" case, but if we somehow do not have a
  // consent mode + a category, force it into ACE
  if (categoryCode) {
    return { mode: CONSENT_MODES.ace, category: categoryCode };
  }

  // legacy consent
  return null;
}
